// extracted by mini-css-extract-plugin
export default {"root":"AddCommentModal_root__5HOYH"};